import React from 'react';
import { ThemeProvider } from '@context/ThemeContext';
import { WalletProvider } from '@context/WalletContext';
import { AppProvider } from '@context/AppContext';

const CombinedProviders = ({ children }) => {
  return (
    <ThemeProvider>
      <WalletProvider>
        <AppProvider>
          {children}
        </AppProvider>
      </WalletProvider>
    </ThemeProvider>
  );
};

export default CombinedProviders;
